import { useState, useCallback } from 'react';
import { getLocations, getBranches } from './locationSlice';
import Loading from '../../../Components/Loading';
import { IconButton, InputAdornment, OutlinedInput } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { Location } from '../../../Types/Location';
import { Card, CardBody, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Clear, Search } from '@mui/icons-material';

const LocationList = () => {
    const [query, setQuery] = useState<string>('');
    const [searchData, setSearchData] = useState<Location []>([]);
    const branchData = useAppSelector<Location []>(getLocations);
    const isLoading = useAppSelector((state) => state.locations.loading)
    const { error } = useAppSelector((state) => state.locations.error)
    const dispatch = useAppDispatch();

    const handleSearch = (text: string) => {
        setQuery(text)
        if (text === '') {
            setSearchData(branchData)
        } else {
            const newSearchData = branchData.filter(branch => 
                branch.id.toString().includes(text.toString()) ||
                branch.name.toLowerCase().includes(text.toLowerCase()) ||
                branch.manager.toLowerCase().includes(text.toLowerCase())
            )
            setSearchData(newSearchData)
        }
    }

    const renderItem = ({ item }: { item: Location }) => {
        return (
            <Link 
                to={`/Locations/${item.id}`}
                state={{ item }}
                style={{ textDecoration: 'none', color: 'black' }}
            >
                <Card>
                    <CardBody className='text-start'>
                        <span className='d-block fw-bold'>#{item.id} {item.name}</span>
                        <span className='d-block'>{item.address1}</span>
                    </CardBody>
                </Card>
            </Link>
        )
    }

    const onRefresh = useCallback(() => {
        dispatch(getBranches())
    }, [dispatch])

    return (
        <>
            {isLoading ? (
                    <Loading />
            ) : (
                <div style={{ flex: 1 }}>
                    <div
                        style={{
                            position: 'sticky',
                            top: 60,
                            zIndex: 1000,
                            paddingBlock: '10px',
                        }}
                        className='bg-light'
                    >
                        <OutlinedInput 
                            id='search'
                            style={{ width: '75%' }}
                            value={query}
                            className='bg-white shadow-sm'
                            onChange={(e) => handleSearch(e.target.value)}
                            placeholder='Search'
                            autoCapitalize='none'
                            autoCorrect='none'
                            startAdornment={
                                <InputAdornment position='start'>
                                    <IconButton
                                        edge='start'
                                    >
                                        {query ? <Search /> : null}
                                    </IconButton>
                                </InputAdornment>
                            }
                            endAdornment={
                                <InputAdornment position='end'>
                                    <IconButton
                                        onClick={() => {
                                            handleSearch('');
                                            setSearchData([]);
                                        }}
                                        edge='end'
                                    >
                                        {query ? <Clear /> : null}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                    </div>
                    <Container>
                        {(!query ? branchData : searchData).map((item) => (
                            renderItem({ item })
                        ))}
                        {error && <span style={{ color: 'red '}}>{error}</span> }
                    </Container>
                </div>
            )}
        </>
    )
};

export default LocationList;